import { Box, Link, Typography } from "@mui/material";
import { IconComponent } from "src/shared/components";
import { EIconNames } from "src/shared/types/iconNames";

const webcomUrl = "https://www.webcom-group.com/";

const headerLinks = [
  { text: "About us", url: "about-us" },
  { text: "Our business", url: "our-business" },
  { text: "Clients", url: "clients" },
  { text: "Contracts", url: "contracts" },
  { text: "Contacts", url: "contacts" },
];

export const SignInHeader = () => {
  return (
    <Box
      sx={{ position: "relative", zIndex: 2, color: "white", maxWidth: "100%" }}
    >
      <Box
        sx={{
          width: "860px",
          maxWidth: "100%",
          mx: "auto",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyConten: "space-between",
          px: 4,
        }}
      >
        <Link href={webcomUrl} target="blank">
          <IconComponent
            iconname={EIconNames.WEBCOM_LOGO}
            sx={{ width: 170, height: 36 }}
          />
        </Link>
        {headerLinks.map(({ text, url }) => (
          <Link
            underline="hover"
            key={url}
            href={webcomUrl + url}
            target="blank"
            color="inherit"
          >
            <Typography component="span">{text}</Typography>
          </Link>
        ))}
      </Box>
    </Box>
  );
};
